<template>
  <div class="english-container">
    <h2>1. Primeros pasos</h2>
    <p  style="text-align: left;" >Para evitar apagados accidentales que puedan impedir la localización del dispositivo, hemos mejorado nuevamente los métodos de encendido y apagado.
</p>
  

<h4> 1.1 Encendido/Apagado</h4>
  <p style="text-align: left;">1.1.1 Encendido: Mantenga presionado durante 3 segundos el punto circular del botón de encendido del dispositivo. Cuando escuche un sonido de timbre, significa que el dispositivo se ha encendido. (Consulte el diagrama) </p>

   <img src="../assets/gid_1.png" alt="Wireless Tag Logo" class="image_1" />

  
  <p style="text-align: left;">
     1.1.2 Apagado: Presione dos veces el botón del dispositivo y escuchará un sonido de confirmación. Luego, mantenga presionado el botón de encendido durante 3 segundos (si lo presiona durante menos de 3 segundos o más de 3 segundos, el dispositivo no se apagará) y, a continuación, <strong>suéltelo...</strong>. Escuchará dos pitidos que indican que el dispositivo se ha apagado.
  </p>
  <p style="text-align: left;">
    <strong>Nota: La configuración de un temporizador de apagado está diseñada para evitar apagados accidentales y garantizar que el dispositivo pueda seguir localizándose correctamente.</strong>
  </p>

  

<h4>1.2 Buscar actualizaciones</h4>
  
      <p style="text-align: left;">
        Para utilizar la aplicación Apple® Find My® para localizar el dispositivo Locator, se recomienda la versión más reciente de
        iOS®, iPadOS® o macOS®. La aplicación Find My en Apple Watch requiere la versión más reciente de watchOS®.    
  </p>
 

<h3>2. Añadir su Locator</h3>
<h4>2.1 Iniciar la aplicación</h4>
<p style="text-align: left;">
  2.1.1 Abra la aplicación Find My en su iPhone® o iPad® compatible.
</p>
<p style="text-align: left;">
2.1.2 Permita las notificaciones de la aplicación.
</p>

<h4>2.2 Conectar su Locator</h4>
  <p style="text-align: left;">
   2.2.1 Encienda su Locator, seleccione la pestaña “Objetos”, luego toque “Añadir objeto” y toque <strong>“Otros objetos compatibles”</strong>.
</p>
<p style="text-align: left;">
2.2.2 Asegúrese de que su Locator esté cerca del teléfono. Espere... hasta que aparezca la ventana emergente “Wireless tag” y luego toque “Conectar”.
</p>

<p style="text-align: left;">
  2.2.3 Elija un nombre y un emoji reconocibles para su Locator y toque “Continuar”. 
</p>

<p style="text-align: left;">
  2.2.4 Find My le pedirá que confirme la adición de su Locator a su Apple ID. Toque “Continuar”.
</p>

<p style="text-align: left;">
  2.2.5 Toque “Finalizar” y su Locator quedará configurado y listo para conectarse al objeto que desee localizar, por ejemplo, sus llaves.
</p>

<h3>3. Introducción a las funciones</h3>

<h4>3.1 Localizar su objeto</h4>
 <p style="text-align: left;">
Cuando su objeto esté cerca, toque “Reproducir sonido” para que su Locator emita un pitido y así poder encontrarlo. Cuando esté fuera de alcance, podrá consultar la última ubicación conocida de su Locator.
  </p>

  <h4>3.2 Notificaciones</h4>

   <p style="text-align: left;">
Recibirá una notificación cuando deje atrás su Locator y este ya no esté dentro del alcance de su dispositivo.
  </p>
  <p style="text-align: left;"> Nota: “Notificar cuando se encuentre” solo puede activarse cuando su
Locator esté fuera de alcance.</p>


  <h4>3.3 Compartir objetos</h4>
   <p style="text-align: left;">
Las personas con las que lo haya compartido podrán localizarlo y
no recibirán notificaciones de seguimiento no identificado.  </p>

<p style="text-align: left;">
Para utilizar Compartir objetos, asegúrese de que usted y sus amigos hayan instalado las versiones beta públicas de iOS 17, iPadOS 17 o macOS 14 Sonoma, o versiones posteriores.

</p>

  <h4>3.4 Modo perdido</h4>
   <p style="text-align: left;">
Cuando pierda su objeto, active el modo perdido. Recibirá una notificación cuando la ubicación esté disponible. Puede dejar un número de teléfono o una dirección de correo electrónico para que quien encuentre su objeto pueda ponerse en contacto con usted.
  </p>

     <p style="text-align: left;">
Nota: Cuando el “Modo perdido” está activado, su Locator queda bloqueado
y nadie más podrá vincularlo. NO ELIMINE EL OBJETO de la aplicación. Su Locator quedará bloqueado y no podrá ser utilizado por ninguna persona.
  </p>
  
 <h4>3.5 Eliminar objeto</h4>
  <p style="text-align: left;">
Asegúrese de que el objeto esté cerca. Puede eliminarlo desde la aplicación; el dispositivo emitirá un sonido de timbre para indicar que se ha eliminado correctamente. Después, otras personas podrán utilizarlo.
  </p>

   <p style="text-align: left;">
Nota: Cuando el “Modo perdido” está activado, NO ELIMINE EL OBJETO de la aplicación; de lo contrario, su Locator quedará bloqueado y nadie más
podrá vincularlo.
  </p>

  <h4>3.6 Restablecer los ajustes de fábrica de su Locator  </h4>

   <p style="text-align: left;">
Cuando el objeto esté fuera del alcance de su teléfono y su Locator haya sido eliminado de la aplicación Find My, otras personas no podrán utilizar el dispositivo. Debe restablecer su Locator para que otras personas puedan utilizarlo.  </p>

   <p style="text-align: left;">
Cómo restablecer los ajustes de fábrica: Presione dos veces el botón de función; escuchará un pitido. Luego, presione rápidamente el botón de función cuatro veces y, en la quinta pulsación, manténgalo presionado hasta escuchar un sonido de timbre. Ahora el dispositivo se ha restablecido. El dispositivo puede vincularse a una nueva cuenta de Apple ID como un dispositivo nuevo.  </p>

<h4>3.7 Detección de seguimiento no deseado</h4>
<p style="text-align: left;">
Si un accesorio de la red Find My separado de su propietario se detecta moviéndose con usted durante un tiempo, recibirá una notificación de una de estas dos maneras: (1) Si tiene un iPhone o iPad, Find My enviará una notificación a su dispositivo Apple. Esta función está disponible en iOS o iPadOS 14.5 o posteriores. (2) Si no tiene un dispositivo iOS o un smartphone, un accesorio de la red Find My que haya permanecido separado de su propietario durante un período de tiempo emitirá un sonido cuando se mueva.</p>
<p style="text-align: left;"> 
  Estas funciones se han creado específicamente para disuadir a otras personas de intentar rastrearlo sin su conocimiento.
</p>
<h3>4. Especificaciones</h3>
<ul>  
  <li>Batería: CR2032 3 V (reemplazable)</li>
  <li>Voltaje de funcionamiento: 2,8 V-3,3 V</li>
  <li>Capacidad: 220 mAh</li>
  <li>Alcance inalámbrico: 10-30 metros</li>
  <li>Zumbador: máx. 100 dB</li>
  <li>Tamaño del producto: φ32 × 7,9 mm</li>

  </ul>



  <h3>5. Funciones del botón</h3>
  <ol>
    <li style="text-align: left;">
      <strong>Encendido (la función Find My está activada).</strong>
      <p>
        Mantenga presionado el botón de función durante 3 segundos para encenderlo. El dispositivo emitirá un sonido de timbre que indica que está encendido.        </p>
      <p> Si el producto no está vinculado a su Apple ID, se apagará automáticamente después de 10 minutos. Deberá activar nuevamente la función Find My para continuar con la vinculación.</p>
      </li>
    <li style="text-align: left;"> <strong>Apagado (la función Find My está desactivada).</strong> 
      <p>
        Mantenga presionado el botón de función durante tres segundos y luego suéltelo. Escuchará dos pitidos que indican que está apagado.      </p>
    </li>
     <li style="text-align: left;"> <strong>Activar la consulta de información adicional.</strong> 
      <p>
Presione rápidamente el botón de función dos veces y escuchará un sonido de confirmación. Esta operación se mostrará en la aplicación Find My para guiar a la persona que encuentre el dispositivo a obtener
</p>

      <p>
información, como los datos de contacto del propietario (si el objeto está configurado en modo perdido en la aplicación) y el número de serie del dispositivo.
</p>
</li>

 <li style="text-align: left;"> <strong> Restablecer los ajustes de fábrica</strong>
  <p>
Presione dos veces el botón de función; escuchará un pitido. Luego, presione rápidamente el botón de función cuatro veces y, en la quinta pulsación, manténgalo presionado hasta escuchar un sonido de timbre. Ahora el dispositivo se ha restablecido.</p>
  
<p style="text-align: left;">
Es necesario restablecer el dispositivo para que entre en el estado de vinculación</p>

</li>
</ol>

 <h3>6. Reemplazo de la batería y del cordón</h3>
 <ol> 
    <li>Inserte la herramienta de apertura en la ranura de apertura de la carcasa.</li>
    <li>Gire la herramienta de apertura de la carcasa 90 grados para abrirla.</li>
    <li>Use las uñas en la pequeña ranura lateral de su Locator para abrir cuidadosamente la carcasa.</li>
    <li>Reemplace la batería por una nueva CR2032 de 3 V. (El polo positivo debe quedar hacia arriba, con el texto visible).</li>

 </ol>

      <img src="../assets/open_tag.png" alt="Wireless Tag Logo" class="image_1" />
      <img src="../assets/open_tag_2.png" alt="Wireless Tag Logo" class="image_1" />



  <h3>  Preguntas frecuentes  </h3>
  <h4>1. ¿Por qué no se actualiza la ubicación de mi dispositivo?</h4>
    <li style="text-align: left;">Existen dos principios para el envío de la ubicación del producto. Si hay muchos dispositivos Apple cerca, cada nuevo usuario en las proximidades de este dispositivo informará de su ubicación, normalmente en un plazo de 2 a 5 minutos. Si el dispositivo no se ha movido, los sensores integrados lo detectarán y el dispositivo entrará en modo de suspensión, por lo que la ubicación puede tardar entre 30 minutos y varias horas en actualizarse. No se preocupe: la ubicación que ve puede corresponder a hace 30 minutos o varias horas, pero es muy probable que el objeto no se haya movido y que la ubicación mostrada sea la última ubicación conocida.</li>
<h4>2. Al vincular un dispositivo con la aplicación Find My, el teléfono se conectará al servidor de Apple. La vinculación puede fallar debido a problemas de red. Se recomienda realizar las siguientes acciones: </h4>
<ol>
  <li style="text-align: left;">Cambie la red del teléfono, por ejemplo, alternando entre Wi-Fi y datos móviles. La primera vinculación puede tardar bastante tiempo; espere pacientemente.
</li>
  <li style="text-align: left;">Restablezca su objeto.</li>
<li style="text-align: left;"> Vuelva a vincularlo mediante la aplicación Find My.
</li>
</ol>
<h3>Privacidad y seguridad</h3>
<p style="text-align: left; color:#333 "  >Su Locator emite una señal Bluetooth segura que puede ser detectada por dispositivos cercanos de la red Find My. Estos dispositivos envían la ubicación de su Locator a iCloud; después, puede abrir la aplicación Find My y verla en un mapa. Todo el proceso es anónimo y está cifrado para proteger su privacidad.</p>

<h3>ADVERTENCIA</h3>
<ol>
  <li>Retire y recicle o deseche inmediatamente las baterías usadas de acuerdo con las normativas locales y manténgalas fuera del alcance de los niños. NO deseche las baterías con la basura doméstica ni las incinere.</li>
  <li>Incluso las baterías usadas pueden causar lesiones graves o la muerte.</li>
  <li>Llame a un centro local de control de intoxicaciones para obtener información sobre el tratamiento.</li>
  <li>Las baterías no recargables no deben recargarse.</li>
  <li>No fuerce la descarga, no recargue, desmonte, caliente por encima de 50 °C/122 °F ni incinere la batería.</li>
  <li>Hacerlo puede provocar lesiones debido a la ventilación, fugas o explosión, lo que puede causar quemaduras químicas. 6. El tipo de batería compatible es CR2032.</li>
  <li>Voltaje nominal de la batería: CC 3 V</li>
  <li>Asegúrese de instalar las baterías correctamente según la polaridad (+ y -). 9. No mezcle baterías nuevas y usadas, ni baterías de diferentes marcas o tipos, como alcalinas, de zinc-carbono o recargables.</li>
  <li>Retire y recicle o deseche inmediatamente las baterías de equipos que no se utilicen durante un período prolongado, de acuerdo con las normativas locales.</li>
  <li> Asegúrese siempre de que el compartimento de la batería esté completamente cerrado. Si el compartimento no se cierra de forma segura, deje de utilizar el producto, retire las baterías y manténgalas fuera del alcance de los niños.</li>
</ol>
<h5>
  <p>Tipo de batería: CR2032. Voltaje de la batería: 3 V.</p>
<p>Manténgala en su embalaje original hasta que esté lista para su uso;</p>
<p>Deseche inmediatamente las baterías usadas y manténgalas fuera del alcance de los niños. NO deseche las baterías con la basura doméstica.</p>
</h5>

<img src="../assets/image_battery.png" class="image_1">

</div>

</template>

<script>
export default {
  name: 'IosSpanish',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>